import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import BankAccountList from 'components/Lists/BankAccountList'
import AddBankAccountModal from 'pages/Modals/AddBankAccountModal'
import SecondaryButton from 'components/Buttons/SecondaryButton'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { Container, Row } from '../styles'

export default function ConfigBankAccounts () {
  const [loading, setLoading] = useState (true)
  const [businessBankAccounts, setBusinessBankAccounts] = useState ([])
  const [showAddBankAccountModal, setShowAddBankAccountModal] = useState (false)
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getData ()
  }, [])

  const getData = async () => {
    try {
      setLoading (true)
      const { data: bankAccounts } = await cutileiApi.get (
        `/businesses/${businessId}/bank_accounts`, requestConfig
      )

      setBusinessBankAccounts (bankAccounts)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  const toggleAddBankAccountModal = () => setShowAddBankAccountModal (!showAddBankAccountModal)

  return (
    <Container>
      {AuthService.hasPermission ('business_config.bank_accounts', 'edit') && (
        <Row>
          <SecondaryButton
            label='Nova conta bancária'
            onClick={toggleAddBankAccountModal}
            width={180}
          />
          <AddBankAccountModal
            visible={showAddBankAccountModal}
            onConfirm={bankAccount => setBusinessBankAccounts (
              [...businessBankAccounts, bankAccount]
            )}
            onClose={toggleAddBankAccountModal}
          />
        </Row>
      )}
      {loading ? <Loading/> : (
        <BankAccountList
          bankAccounts={businessBankAccounts}
          onEdit={bankAccount => 
            setBusinessBankAccounts (businessBankAccounts.map (ba => 
              ba.id === bankAccount.id ? {...bankAccount} : ba
            ))
          }
          onDelete={bankAccount => setBusinessBankAccounts (
            businessBankAccounts.filter (ba => ba.id !== bankAccount.id)
          )}
        />
      )}
    </Container>
  )
}
